var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3934 27.6066C5.00052 26.2137 3.89563 24.5601 3.14181 22.7402C2.38799 20.9204 2 18.9698 2 17C2 15.0302 2.38799 13.0796 3.14181 11.2597C3.89563 9.43986 5.00052 7.78628 6.3934 6.3934C7.78628 5.00052 9.43987 3.89563 11.2598 3.14181C13.0796 2.38799 15.0302 2 17 2C18.9698 2 20.9204 2.38799 22.7403 3.14181C24.5601 3.89563 26.2137 5.00052 27.6066 6.3934L6.3934 27.6066Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 17C0.5 7.90024 7.90024 0.5 17 0.5C26.0998 0.5 33.5 7.90024 33.5 17C33.5 26.0998 26.0998 33.5 17 33.5C7.90024 33.5 0.5 26.0998 0.5 17ZM17 3.5C9.55709 3.5 3.5 9.55709 3.5 17C3.5 24.4429 9.55709 30.5 17 30.5C24.4429 30.5 30.5 24.4429 30.5 17C30.5 9.55709 24.4429 3.5 17 3.5Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3333 11.9393C24.9191 12.5251 24.9191 13.4749 24.3333 14.0607L16.1515 22.2425C15.5657 22.8283 14.616 22.8283 14.0302 22.2425L9.93934 18.1516C9.35355 17.5658 9.35355 16.6161 9.93934 16.0303C10.5251 15.4445 11.4749 15.4445 12.0607 16.0303L15.0909 19.0605L22.212 11.9393C22.7978 11.3536 23.7476 11.3536 24.3333 11.9393Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.2976299575c395dc8c2272cc86be5c43.svg";
export { ForwardRef as ReactComponent };